import { useState, useEffect } from 'react';

function dispatchFilterUpdate (dispatch, filterName, value) {
    dispatch({
        type: 'SET_FILTER',
        payload: {filterName, value}
    });
}; 

function dispatchSubheaderTextUpdate (dispatch, input) {
    dispatch({
        type: 'SET_SUBHEADER_TEXT',
        payload: input
    });
}; 

function dispatchSideMenuToggle (dispatch, payload) {
    dispatch({
        type: 'TOGGLE_SIDEMENU',
        payload
    })
};

function dispatchSummaryToggle (dispatch, payload) {
    dispatch({
        type: 'TOGGLE_SUMMARY_OPEN',
        payload
    })
};

function dispatchArticlesData (dispatch, payload) {
    dispatch({
        type: 'SET_ARTICLES_DATA',
        payload
    })
};

function dispatchUserSelections (dispatch, payload) {
    dispatch({
        type: 'SET_USER_SELECTIONS',
        payload
    })
};

function dispatchCompositionArticles (dispatch, payload) {
    dispatch({
        type: 'SET_COMPOSITION_ARTICLES',
        payload
    })
};

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
};
  
function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
};

function openDialogWindow (dispatch) {
    dispatch({
        type: 'SET_IS_APP_ACTIVE',
        payload: false
    })
};

function setLanguage (dispatch, payload) {
    dispatch({
        type: 'SET_LANGUAGE',
        payload
    })
}

export {
    dispatchFilterUpdate,
    dispatchSubheaderTextUpdate,
    dispatchSideMenuToggle,
    dispatchSummaryToggle,
    dispatchArticlesData,
    dispatchUserSelections,
    dispatchCompositionArticles,
    useWindowDimensions,
    openDialogWindow,
    setLanguage
}


